import { ProjectResponseGetById } from '@customer-apps/api-planning-projects';
import { CountryCode } from '@customer-apps/shared/enums';

export const isOfCountry = (source: ProjectResponseGetById | CountryCode, comparison: CountryCode | CountryCode[]): boolean => {
    const addressCountryCode = (source as ProjectResponseGetById).address?.countryCode || source;
    return Array.isArray(comparison) ? comparison.includes(addressCountryCode as CountryCode) : addressCountryCode === comparison;
};
